import { useReferralMapping } from 'app/components/mapping-referral/useReferralMapping'
import { ReferralMappingShadcnComponent } from 'app/components/mapping-referral/ReferralMappingShadcnComponent'

export default function ReferralMappingPage(): React.ReactElement {
  const hookData = useReferralMapping()
  return <ReferralMappingShadcnComponent {...hookData} />
}
